export default function Features() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-bold leading-tight">
            <span className="text-slate-900">選ばれる</span>
            <span className="text-slate-900">理由</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-6 h-[600px]">
          {/* Left Large Card */}
          <div className="relative rounded-2xl overflow-hidden shadow-lg group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20real%20estate%20consultant%20having%20friendly%20consultation%20meeting%20with%20clients%20in%20modern%20bright%20office%2C%20warm%20atmosphere%20with%20natural%20lighting%2C%20business%20people%20discussing%20property%20documents%20and%20plans%20on%20table%2C%20trust%20and%20expertise%20conveyed%20through%20body%20language&width=800&height=1200&seq=feat-001&orientation=portrait"
              alt="専門家による無料相談"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent"></div>
            <div className="absolute bottom-8 left-8">
              <div className="bg-slate-900/60 backdrop-blur-md text-white px-6 py-3 rounded-lg">
                <p className="text-lg font-medium">専門家による無料相談</p>
              </div>
            </div>
          </div>

          {/* Right Two Cards */}
          <div className="flex flex-col gap-6">
            {/* Top Card */}
            <div className="relative rounded-2xl overflow-hidden shadow-lg bg-slate-50 flex-1 group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Business%20handshake%20over%20signed%20real%20estate%20contract%20documents%20on%20modern%20desk%2C%20professional%20setting%20with%20warm%20lighting%2C%20legal%20papers%20and%20pen%20visible%2C%20trust%20and%20agreement%20symbolized%2C%20clean%20composition%20with%20soft%20focus%20background&width=1200&height=500&seq=feat-002&orientation=landscape"
                alt="安心の契約サポート"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <div className="bg-slate-900/60 backdrop-blur-md text-white px-5 py-2.5 rounded-lg">
                  <p className="text-base font-medium">安心の契約サポート</p>
                </div>
              </div>
            </div>

            {/* Bottom Card */}
            <div className="relative rounded-2xl overflow-hidden shadow-lg bg-amber-50 flex-1 group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Hand%20holding%20new%20house%20keys%20with%20modern%20apartment%20interior%20blurred%20in%20background%2C%20warm%20welcoming%20atmosphere%2C%20symbol%20of%20new%20home%20ownership%20and%20moving%20in%2C%20professional%20real%20estate%20photography%20with%20soft%20natural%20lighting&width=1200&height=500&seq=feat-003&orientation=landscape"
                alt="アフターフォロー充実"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <div className="bg-slate-900/60 backdrop-blur-md text-white px-5 py-2.5 rounded-lg">
                  <p className="text-base font-medium">アフターフォロー充実</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
